import { ImageGallery } from '../../components/ImageGallery';
import { DesktopOnly, MobileOnly } from '../../components/Layout';
import { PageSection } from '../../components/Section';
import { SkeletonCard, SkeletonRow } from '../../components/SkeletonCard';
import { AccommodationContentPanel } from '../../composites/AccommodationContentPanel';
import { SplitLayout } from '../../composites/SplitLayout';
import { space } from '../../theme/tokens';
import type { AccommodationDetailTemplateProps } from './AccommodationDetailTemplate.types';

export function AccommodationDetailTemplate({
  images = [],
  onBack,
  previousImageLabel,
  nextImageLabel,
  goToImageLabel,
  viewAllLabel,
  journeyBar,
  recommendations,
  ...contentProps
}: AccommodationDetailTemplateProps) {
  const showRecommendations = contentProps.isLoading || !!recommendations;

  return (
    <>
      <SplitLayout
        mobileHorizontalPadding={space['space-600']}
        leftWidth="min(58%, calc(100% - 440px))"
        contentMaxWidth="560px"
        left={
          <ImageGallery
            images={images}
            onBack={onBack}
            sticky
            prevLabel={previousImageLabel}
            nextLabel={nextImageLabel}
            goToImageLabel={goToImageLabel}
            backLabel={viewAllLabel}
            overlayContent={journeyBar ? <MobileOnly>{journeyBar}</MobileOnly> : undefined}
          />
        }
        right={
          <>
            {journeyBar && <DesktopOnly>{journeyBar}</DesktopOnly>}
            <AccommodationContentPanel {...contentProps} />
          </>
        }
      />

      {showRecommendations && (
        <PageSection>
          {contentProps.isLoading ? (
            <SkeletonRow>
              {Array.from({ length: 4 }).map((_, i) => (
                <SkeletonCard key={i} variant="grid" />
              ))}
            </SkeletonRow>
          ) : (
            recommendations
          )}
        </PageSection>
      )}
    </>
  );
}
